import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Support } from "~/features-deprecated/support/Support";
import MosGram from "~/icons/MosGram";
import TelegramBot from "~/icons/TelegramBot";
import WeChatBot from "~/icons/WeChatBot";

const support = [
  {
    url: "#",
    icon: <TelegramBot viewBox="0 0 140 140" />,
    alt: "telegram-bot",
  },
  {
    url: "#",
    icon: <MosGram viewBox="0 0 140 140" />,
    alt: "mosgram",
  },
  {
    url: "#",
    icon: <WeChatBot viewBox="0 0 140 140" />,
    alt: "wechat-bot",
  },
];
export const SupportMessengers: FC = () => {
  const { t } = useTranslation("support");
  return <Support title={t("support.heading.title")} messengers={support} />;
};
